import { inject, singleton } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

import {
    ConceptEnhancementRepository,
    RequestGetConceptEnhancementsPayload,
} from "@/entities/concept-enhancement/domain/repository";
import type { GetConceptEnhancementsResponseDto } from "@/entities/concept-enhancement/domain/dtos";

@singleton()
export default class ConceptEnhancementRepositoryImpl implements ConceptEnhancementRepository {
    constructor(@inject("HttpAdapter") private readonly server: HttpAdapter) {}

    async getConceptEnhancements(
        payload: RequestGetConceptEnhancementsPayload,
    ): Promise<GetConceptEnhancementsResponseDto> {
        let url = `/v1/concept-enhancements?include=class&include=chapters&academyId=${payload.academyId}&`;

        if (payload.from) {
            url += `from=${payload.from}&`;
        }

        if (payload.to) {
            url += `to=${payload.to}&`;
        }

        if (payload.orders) {
            url += `orders=${payload.orders}&`;
        }

        if (payload.classId) {
            url += `classId=${payload.classId}&`;
        }

        if (payload.succeedStatus !== undefined) {
            url += `succeedStatus=${payload.succeedStatus}&`;
        }

        if (payload.keyword) {
            url += `keyword=${payload.keyword}&`;
        }

        if (payload.semesterId) {
            url += `semesterId=${payload.semesterId}&`;
        }

        if (payload.middleUnitId && payload.middleUnitId.length > 0) {
            for (const middleUnitId of payload.middleUnitId) {
                url += `middleUnitId=${middleUnitId}&`;
            }
        }

        if (payload.size) {
            url += `size=${payload.size}&`;
        }

        if (payload.nextToken) {
            url += `nextToken=${payload.nextToken}&`;
        }

        const response = await this.server.get<GetConceptEnhancementsResponseDto>(url);

        return response;
    }
}
